import {
    updatePOSWashing
    , getDashboardJobStatus
    , setWDFManualStatus
    , deleteWDFManualStatus
} from '../utils/api-action';



const posWashing = async (param) => {
    var result = await updatePOSWashing(param)
    return result;
}

const dashboardJobStatus = async (param) => {
    var result = await getDashboardJobStatus(param)
    return result;
}

const wdfManualStatus = async (param) => {
    var result = await setWDFManualStatus(param)
    return result;
}

const wdfDeleteStatus = async (param) => {
    var result = await deleteWDFManualStatus(param)
    return result;
}


export {
    posWashing
    , dashboardJobStatus
    , wdfManualStatus
    , wdfDeleteStatus
}